/* POPNAME: velikosti skladem v kartách produktů Findter (kolekce/vyhledávání).
   Findter vykresluje vlastní karty, takže nastavení šablony se na ně nevztahuje.
   Skript dočte varianty z /products/<handle>.js a dostupné hodnoty volby "Velikost"
   vloží na místo ceny (cena se na desktopu při najetí myší schová, viz custom.css). */
(() => {
  const OPTION = 'Velikost';
  const cache = new Map();
  const getProduct = (handle) => {
    if (!cache.has(handle)) {
      cache.set(handle, fetch('/products/' + handle + '.js')
        .then((r) => (r.ok ? r.json() : null))
        .catch(() => null));
    }
    return cache.get(handle);
  };

  async function enhance(item) {
    const state = item.dataset.pnSwap;
    if (state === 'pending' || state === 'none') return;
    if (item.querySelector('.pn-swap .pn-sizes')) return;
    const link = item.querySelector('a[href*="/products/"]');
    const price = item.querySelector('.search-filters__product-info .search-filters__product-price');
    if (!link || !price) return;
    item.dataset.pnSwap = 'pending';
    try {
      const handle = link.getAttribute('href').split('/products/')[1].split(/[?#/]/)[0];
      const product = await getProduct(handle);
      const idx = product ? product.options.findIndex((o) => (o && o.name ? o.name : o) === OPTION) : -1;
      const sizes = [];
      if (idx >= 0) {
        const key = 'option' + (idx + 1);
        product.variants.forEach((v) => {
          if (v.available && !sizes.includes(v[key])) sizes.push(v[key]);
        });
      }
      if (!sizes.length) {
        item.dataset.pnSwap = 'none';
        return;
      }
      const row = document.createElement('div');
      row.className = 'pn-sizes';
      sizes.forEach((s) => {
        const span = document.createElement('span');
        span.className = 'pn-sizes__item';
        span.textContent = s;
        row.appendChild(span);
      });
      const swap = document.createElement('div');
      swap.className = 'pn-swap';
      price.parentNode.insertBefore(swap, price);
      swap.appendChild(price);
      swap.appendChild(row);
      item.dataset.pnSwap = 'done';
    } catch (e) {
      item.dataset.pnSwap = 'none';
    }
  }

  let queued = false;
  const scan = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      document.querySelectorAll('.search-filters__product-item').forEach(enhance);
    });
  };
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
  scan();
})();
